// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal_modal__2axiW","open":"modal_open__9YsvS","alert":"modal_alert__3BESZ"};